import { useEffect, useState } from 'react';
import DateRange from '../../Components/DateRange/DateRange';
import TabButton from '../../Components/TabButton/TabButton';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { changeSection, changeSubSection } from '../../Features/financeManagementSlice';
import SalesSummaryStats from './Components/Stats/SalesSummaryStats';
import OrderSummaryStats from './Components/Stats/OrderSummaryStats';
import SalesSummary from './Components/SalesSummary/SalesSummary';
import CreditNote from './Components/CreditNote/CreditNote';
import CreditNoteStats from './Components/Stats/CreditNoteStats';
import OrderSummary from './Components/OrderSummary/OrderSummary';
import PayoutSummaryList from './Components/PayoutSummary/PayoutSummaryList';

const sectionsList = [
    {
        id: 'eligible-orders',
        name: 'Eligible Orders',
    },
    {
        id: 'order-summary',
        name: 'Order Summary',
    },
    {
        id: 'payout-summary',
        name: 'Payout Summary',
    },
];

const subSectionsList = [
    {
        id: 'sales-summary',
        name: 'Sales Summary',
    },
    {
        id: 'return-and-credit-note',
        name: 'Return & Credit Note',
    },
];

function FinanceManagement() {
    const dispatch = useDispatch();

    const section = useSelector((state) => state.financeManagement.section);
    const subSection = useSelector((state) => state.financeManagement.subSection);

    const handleSectionSelect = (selection) => {
        dispatch(changeSection(selection));
        if(selection !== 'eligible-orders' && selection !== section) {
            dispatch(changeSubSection('sales-summary'));
        }
    }

    const handleSubSectionSelect = (selection) => {
        dispatch(changeSubSection(selection));
    }

    const [financeDateRange, setFinanceDateRange] = useState({ startDate: '', endDate: '' });

    const handleDateRangeChange = (newDateRange) => {
        setFinanceDateRange(newDateRange);
    }

    useEffect(() => {
        if(financeDateRange.startDate && financeDateRange.endDate) {
            let callData = {
                limit: 10000, 
                ...financeDateRange
            }
            // dispatch(fetchFinanceOrders(callData));
            // dispatch(fetchFinanceTransactions(callData));
        }
        // eslint-disable-next-line
    }, [financeDateRange]);

    return (
        <div className="w-full overflow-y-scroll pb-24 outline-none flex flex-col gap-4 select-none">
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit">
                    <h1 className="text-[#121212] font-bold text-2xl">Finance Management</h1>
                </div>
            </div>

            <div className="flex mx-5">
                {sectionsList.map(item => {
                    return (
                        <TabButton 
                            key={item.id} 
                            id={item.id} 
                            optionName={item.name} 
                            selected={section} 
                            handleSelect={handleSectionSelect} 
                        />
                    )
                })}
            </div>

            <div className="mx-5 flex items-center justify-between">
                <p className='font-semibold text-base text-[#121212]'>{sectionsList?.find(item => item.id === section)?.name}</p>

                <DateRange 
                    dateRange={financeDateRange} 
                    changeDateRange={handleDateRangeChange}
                />
            </div>

            {/* Stats */}
            {
                section === 'eligible-orders' && 
                <>
                    {
                        subSection === 'sales-summary' ? 
                        <SalesSummaryStats /> : 
                        <CreditNoteStats />
                    }
                </>
            }

            {section === 'order-summary' && <OrderSummaryStats />}

            {/* SubSection */}
            {
                section === 'eligible-orders' && 
                <div className='flex flex-col gap-3 mx-5'>
                    <div className="flex">
                        {subSectionsList.map(item => {
                            return (
                                <TabButton 
                                    key={item.id} 
                                    id={item.id} 
                                    optionName={item.name} 
                                    selected={subSection} 
                                    handleSelect={handleSubSectionSelect} 
                                />
                            )
                        })}
                    </div>

                    {subSection === 'sales-summary' && <SalesSummary />}

                    {subSection === 'return-and-credit-note' && <CreditNote />}
                </div>
            }

            {section === 'order-summary' && <OrderSummary />}

            {section === 'payout-summary' && <PayoutSummaryList />}
        </div>
    );
}

export default FinanceManagement;
